'use strict';

/*exported Container */
function Container() {
  this.container = null;

  this.init();
}

Container.prototype = $.extend({}, {
  constructor: 'Container',

  //**************************************************************************
  get: function get(id) {
    var _this = this;

    if (!_this.has(id)) {
      throw id + ' does not exists in container!';
    }

    return _this.container[id];
  },

  getAll: function getAll() {
    var _this = this;

    return _this.container;
  },

  set: function set(id, value) {
    var _this = this;

    _this.container[id] = value;
    return _this;
  },

  has: function has(id) {
    var _this = this;

    return id in _this.container;
  },

  loadFromArray: function loadFromArray(array) {
    var _this = this;

    $.each(array, function (id, value) {
      _this.set(id, value);
    });

    return _this;
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    _this.container = {};
  }
});
